import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  /** Muted line under the title */
  children?: ReactNode;
  action?: ReactNode;
}

/** Centred page-body state for nothing to show: no search yet, or no record the operator can see. Failed requests belong in QueryErrorBanner */
export const EmptyState = ({ icon: Icon, title, children, action }: EmptyStateProps) => (
  <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
    <Icon aria-hidden className="size-16 text-muted-foreground/50" />
    <h2 className="text-lg font-medium">{title}</h2>
    {children ? <p className="max-w-lg text-sm text-muted-foreground">{children}</p> : null}
    {action}
  </div>
);
EmptyState.displayName = 'EmptyState';
